import React from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import IncomeSelectField from "./IncomeSelectField";
import { frequencyOptions } from "app/utils/staticValues";
import { LiaQuestionCircle } from "react-icons/lia";
import { Tooltip } from "react-tooltip";
interface Option {
  value: string | number;
  label: string;
}

interface InputFieldProps<T extends FieldValues> {
  label?: string;
  tooltip?: string;
  selectlabel: string;
  selectplaceholder: string;
  selectname: Path<T>;
  selectoptions: Option[];
  name: Path<T>;
  control: Control<T>;
  type: "text" | "password" | "email" | "number" | "tel" | "date";
  placeholder?: string;
  error?: string;
  selecterror?: string;
  required?: boolean;
  hidelabel?: boolean;
  customWidth?: boolean;
  selectrequired?: boolean;
  className?: string;
  rules?: Record<string, any>;
  disabled?: boolean;
}

function IncomeInputs<T extends FieldValues>({
  label,
  selectlabel,
  selectname,
  selectplaceholder,
  name,
  control,
  type,
  placeholder,
  error,
  required = false,
  hidelabel = false,
  selectrequired = false,
  customWidth = false,
  className,
  selecterror,
  rules = {},
  tooltip,
  disabled = false,
}: InputFieldProps<T>) {
  const formattedPlaceholder = placeholder
    ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1).toLowerCase()
    : "";

  return (
    <div className={`text-left relative ${className}`}>
      <label
        htmlFor={name}
        className={` font-Mulish text-[16px] sm:text-base font-normal text-lightBlue mb-1  flex items-center gap-1 ${
          hidelabel && "opacity-0 hidden lg:block"
        }`}
      >
        {label &&
          label?.charAt(0).toUpperCase() + label?.slice(1).toLowerCase()}
        {!tooltip && required && <span className="text-red-500">*</span>}
        {tooltip && (
          <>
            <LiaQuestionCircle
              data-tooltip-id={`tooltip-${name}`}
              className="text-[#D1A960] cursor-pointer text-[20px]"
            />
            <Tooltip
              id={`tooltip-${name}`}
              place="right"
              className="font-Mulish"
              style={{
                backgroundColor: "white",
                color: "#374151",
                fontSize: "14px",
                padding: "8px 12px",
                borderRadius: "8px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                border: "1px solid #E5E7EB",
                maxWidth: "250px",
                zIndex: 999,
              }}
            >
              {tooltip}
            </Tooltip>
          </>
        )}
      </label>
      <div
        className={`w-full rounded-[10px]      ${
          disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""
        }
  border-2 flex justify-between
            ${error || selecterror ? "border-red-500" : "border-[#EAECF0]"}`}
      >
        <div
          className={`${
            customWidth ? "lg:w-[45%]  w-[45%]" : "lg:w-[75%] w-[75%]"
          } `}
        >
          <Controller
            name={name}
            control={control}
            rules={{
              required: required ? `${label} is required` : false,
              ...rules,
            }}
            render={({ field }) => (
              <input
                {...field}
                min={type === "number" ? 0 : undefined}
                step={type === "number" ? "any" : undefined}
                type={type}
                disabled={disabled}
                placeholder={formattedPlaceholder}
                className={`w-full px-4 py-4  font-Mulish rounded-[10px] focus:outline-none placeholder-gray-400     ${
                  disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""
                }          
`}
                onFocus={() => {
                  if (field.value === "0" || field.value === 0) {
                    field.onChange(""); // Clear if value is 0
                  }
                }}
                onKeyDown={(e) => {
                  if (type === "number" && (e.key === "-" || e.key === "e")) {
                    e.preventDefault();
                  }
                }}
              />
            )}
          />
        </div>
        <div
          className={`${
            customWidth ? "lg:w-[55%] w-[55%]" : "lg:w-[25%] w-[75%]"
          } `}
        >
          <IncomeSelectField
            label={selectlabel}
            name={selectname}
            control={control}
            options={frequencyOptions}
            placeholder={selectplaceholder}
            required={selectrequired}
            isDisabled={disabled}
          />
        </div>
      </div>

      {(error || selecterror) && (
        <ErrorsMessage
          title={(error || selecterror)
            ?.toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase())}
          className="text-right absolute top-[100%] right-0"
        />
      )}
    </div>
  );
}

export default IncomeInputs;
